require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon")) : factory(root["./utils"], root["./svgicon"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[15],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(205);


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Container = _interopRequireDefault(__webpack_require__(206));

exports["default"] = _Container["default"];
exports.Container = _Container["default"];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _reactResizable = __webpack_require__(207);

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _resizePanel_ = _interopRequireDefault(__webpack_require__(208));

var _Container = _interopRequireDefault(__webpack_require__(209));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sizeArrayToCss = _utils.cssUtils.sizeArrayToCss,
    mergeStyles = _utils.cssUtils.mergeStyles;
var sanitize = _utils.propsUtils.sanitize;
var isKey = _utils.keyboardUtils.isKey,
    keyNames = _utils.keyboardUtils.keyNames;

var containerClassName = _Container["default"].containerClassName.replace(/"/g, '');

var KB_RESIZE_STEP = 5;

var Container = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Container, _Component);

  function Container(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onResize", function (event, data) {
      _this.setState({
        width: data.size.width,
        height: data.size.height
      });

      _this.props.onResize(event, data);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handler", function (h) {
      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
        "aria-label": "resizable-container__handler",
        "data-tid": "ba-common-resizable-container__handler",
        className: "resize-handler-icon resize-handler-icon-" + h,
        tabIndex: "0",
        onKeyDown: _this._onResizeHandlerKeyDown,
        iconId: _resizePanel_["default"].id
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "react-resizable-handle react-resizable-handle-" + h
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onResizeHandlerKeyDown", function (e) {
      var LEFT = keyNames.LEFT,
          RIGHT = keyNames.RIGHT,
          UP = keyNames.UP,
          DOWN = keyNames.DOWN;
      var _this$props = _this.props,
          resizeDirection = _this$props.resizeDirection,
          resizeMinConstraintsX = _this$props.resizeMinConstraintsX,
          resizeMaxConstraintsX = _this$props.resizeMaxConstraintsX,
          resizeMinConstraintsY = _this$props.resizeMinConstraintsY,
          resizeMaxConstraintsY = _this$props.resizeMaxConstraintsY;
      var _this$state = _this.state,
          width = _this$state.width,
          height = _this$state.height;

      if (isKey(e, LEFT) || isKey(e, RIGHT) || isKey(e, UP) || isKey(e, DOWN)) {
        if (resizeDirection === 'x') {
          if (isKey(e, LEFT) && resizeMinConstraintsX <= width - KB_RESIZE_STEP) {
            _this.setState({
              width: width - KB_RESIZE_STEP
            });
          } else if (isKey(e, RIGHT) && resizeMaxConstraintsX >= width + KB_RESIZE_STEP) {
            _this.setState({
              width: width + KB_RESIZE_STEP
            });
          }
        } else if (resizeDirection === 'y') {
          if (isKey(e, UP) && resizeMinConstraintsY <= height - KB_RESIZE_STEP) {
            _this.setState({
              height: height - KB_RESIZE_STEP
            });
          } else if (isKey(e, DOWN) && resizeMaxConstraintsY >= height + KB_RESIZE_STEP) {
            _this.setState({
              height: height + KB_RESIZE_STEP
            });
          }
        }

        e.preventDefault();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      _this._node = node;
    });
    _this.state = {
      width: 0,
      height: 0
    };
    return _this;
  }

  var _proto = Container.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var resizable = this.props.resizable;

    if (resizable) {
      this.setState({
        height: this._node.offsetHeight,
        width: this._node.offsetWidth
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var resizable = this.props.resizable;

    if (resizable && (prevState.height !== this._node.offsetHeight || prevState.width !== this._node.offsetWidth)) {
      this.setState({
        height: this._node.offsetHeight,
        width: this._node.offsetWidth
      });
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        gutter = _this$props2.gutter,
        margin = _this$props2.margin,
        padding = _this$props2.padding,
        width = _this$props2.width,
        height = _this$props2.height,
        minWidth = _this$props2.minWidth,
        minHeight = _this$props2.minHeight,
        maxWidth = _this$props2.maxWidth,
        maxHeight = _this$props2.maxHeight,
        overflow = _this$props2.overflow,
        relative = _this$props2.relative,
        textAlign = _this$props2.textAlign,
        style = _this$props2.style,
        resizable = _this$props2.resizable,
        resizeDirection = _this$props2.resizeDirection,
        resizeMinConstraintsX = _this$props2.resizeMinConstraintsX,
        resizeMinConstraintsY = _this$props2.resizeMinConstraintsY,
        resizeMaxConstraintsX = _this$props2.resizeMaxConstraintsX,
        resizeMaxConstraintsY = _this$props2.resizeMaxConstraintsY,
        className = _this$props2.className,
        onResizeStart = _this$props2.onResizeStart,
        onResizeStop = _this$props2.onResizeStop,
        id = _this$props2.id,
        resizeHandles = _this$props2.resizeHandles,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["children", "gutter", "margin", "padding", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "overflow", "relative", "textAlign", "style", "resizable", "resizeDirection", "resizeMinConstraintsX", "resizeMinConstraintsY", "resizeMaxConstraintsX", "resizeMaxConstraintsY", "className", "onResizeStart", "onResizeStop", "id", "resizeHandles"]);
    var styles = mergeStyles(style, {
      overflow: overflow,
      width: width,
      height: height,
      minWidth: minWidth,
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      textAlign: textAlign,
      margin: sizeArrayToCss(margin),
      padding: sizeArrayToCss(gutter || padding)
    });

    if (relative) {
      styles.position = 'relative';
    }

    var classNames = (0, _utils.classnames)(containerClassName);
    var containerComponentClass = classNames + " " + className;
    var defaultResizeHandles;

    if (resizable) {
      if (resizeHandles === undefined) {
        switch (resizeDirection) {
          case 'x':
            defaultResizeHandles = ['e'];
            break;

          case 'y':
            defaultResizeHandles = ['s'];
            break;

          case 'both':
            defaultResizeHandles = ['se'];
            break;

          default:
        }
      }

      return /*#__PURE__*/_react["default"].createElement(_reactResizable.Resizable, (0, _extends2["default"])({}, sanitize(others, Container), {
        axis: resizeDirection,
        height: this.state.height,
        width: this.state.width,
        onResize: this._onResize,
        onResizeStart: onResizeStart,
        onResizeStop: onResizeStop,
        minConstraints: [resizeMinConstraintsX, resizeMinConstraintsY],
        maxConstraints: [resizeMaxConstraintsX, resizeMaxConstraintsY],
        resizeHandles: resizeHandles === undefined ? defaultResizeHandles : resizeHandles,
        handle: this._handler
      }), /*#__PURE__*/_react["default"].createElement("div", {
        id: id,
        className: (0, _utils.classnames)(containerComponentClass, resizeDirection),
        style: (0, _extends2["default"])({}, styles, {
          width: this.state.width === 0 ? width : this.state.width,
          height: this.state.height === 0 ? height : this.state.height
        }),
        ref: this._ref
      }, children));
    }

    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      id: id,
      className: containerComponentClass,
      ref: this._ref
    }, sanitize(others, Container), {
      style: styles
    }), children);
  };

  return Container;
}(_react.Component);

exports["default"] = Container;
(0, _defineProperty2["default"])(Container, "propTypes", {
  gutter: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
  margin: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
  padding: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  overflow: _propTypes["default"].string,
  relative: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  textAlign: _propTypes["default"].oneOf(['left', 'right', 'center']),
  style: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types
  resizable: _propTypes["default"].bool,
  resizeDirection: _propTypes["default"].oneOf(['both', 'x', 'y', 'none']),
  resizeMinConstraintsX: _propTypes["default"].number,
  resizeMinConstraintsY: _propTypes["default"].number,
  resizeMaxConstraintsX: _propTypes["default"].number,
  resizeMaxConstraintsY: _propTypes["default"].number,
  onResize: _propTypes["default"].func,
  onResizeStart: _propTypes["default"].func,
  onResizeStop: _propTypes["default"].func,
  className: _propTypes["default"].string,
  id: _propTypes["default"].string,
  resizeHandles: _propTypes["default"].array
});
(0, _defineProperty2["default"])(Container, "defaultProps", {
  resizable: false,
  resizeDirection: 'x',
  className: '',
  style: {},
  resizeMinConstraintsX: 32,
  resizeMinConstraintsY: 32,
  resizeMaxConstraintsX: Number.POSITIVE_INFINITY,
  resizeMaxConstraintsY: Number.POSITIVE_INFINITY,
  onResize: function onResize() {},
  onResizeStart: function onResizeStart() {},
  onResizeStop: function onResizeStop() {}
});

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

module.exports = require("react-resizable");

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/resize-panel_24");

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(210);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-container.react-resizable svg.resize-handler-icon:focus{outline:2px solid #a8c0f3}.ba-common-container.react-resizable{position:relative}.ba-common-container.react-resizable svg.resize-handler-icon{position:absolute;margin:auto;display:block;z-index:2}.ba-common-container.react-resizable .react-resizable-handle{background-color:#eaeaea;box-sizing:border-box;position:absolute;margin:auto}@media screen and (-ms-high-contrast: active){.ba-common-container.react-resizable .react-resizable-handle{border:1px solid #fff}}.ba-common-container.react-resizable.is-x{padding-right:8px;height:100% !important}.ba-common-container.react-resizable.is-x svg.resize-handler-icon-e{width:8px;top:0;bottom:0;right:0}.ba-common-container.react-resizable.is-x svg.resize-handler-icon-w{width:8px;top:0;bottom:0;left:0}.ba-common-container.react-resizable.is-x .react-resizable-handle-e{width:8px;height:100%;top:0;bottom:0;right:0;cursor:col-resize}.ba-common-container.react-resizable.is-x .react-resizable-handle-w{width:8px;height:100%;top:0;bottom:0;left:0;cursor:col-resize}.ba-common-container.react-resizable.is-y{padding-bottom:8px;width:100% !important}.ba-common-container.react-resizable.is-y svg.resize-handler-icon-s{height:16px;left:50%;bottom:-4px;transform:rotate(90deg)}.ba-common-container.react-resizable.is-y svg.resize-handler-icon-n{height:16px;left:50%;top:-4px;transform:rotate(90deg)}.ba-common-container.react-resizable.is-y .react-resizable-handle-n{height:8px;width:100%;top:0;right:0;left:0;cursor:row-resize}.ba-common-container.react-resizable.is-y .react-resizable-handle-s{height:8px;width:100%;bottom:0;right:0;left:0;cursor:row-resize}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-se{width:16px;height:16px;right:0;bottom:0}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-sw{width:16px;height:16px;bottom:0px;left:0px}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-nw{width:16px;height:16px;top:0px;left:0px}.ba-common-container.react-resizable.is-both svg.resize-handler-icon-ne{width:16px;height:16px;top:0px;right:0px}.ba-common-container.react-resizable.is-both .react-resizable-handle-se{width:16px;height:16px;bottom:0;right:0;cursor:se-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-sw{width:16px;height:16px;bottom:0px;left:0px;cursor:sw-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-ne{width:16px;height:16px;top:0px;right:0px;cursor:ne-resize}.ba-common-container.react-resizable.is-both .react-resizable-handle-nw{width:16px;height:16px;top:0px;left:0px;cursor:nw-resize}\n", ""]);

// exports
exports.locals = {
	"containerClassName": "\"ba-common-container\""
};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[204,0]]]);
});